document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".carousel-collections__btn");
  const groups = document.querySelectorAll(".carousel-collections__products");

  buttons.forEach(btn => {
    btn.addEventListener("click", () => {
      const target = btn.dataset.target;

      buttons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      groups.forEach(g => {
        g.classList.toggle("active", g.dataset.collection === target);
      });
    });
  });

});
